<template>
    <settings-page :title="title" :description="description">
        <section class="flex-form__section">
            <h2 class="text-setting__title">Bypass Block</h2>
            <div class="flex-form__field">
                <div class="flex-form__label">Enable Bypass Block</div>
                <toggle
                    v-model="enableBypassBlock"
                    @input="onInput"
                />
            </div>
            <div class="flex-form__field">
                <div class="flex-form__label">Bypass Block Text</div>
                <input
                    v-model="bypassBlockText"
                    class="flex-form__input"
                    type="text"
                    @input="onInput"
                >
            </div>
            <div class="flex-form__field">
                <div class="flex-form__label">Bypass Block Target ID</div>
                <input
                    v-model="targetId"
                    class="flex-form__input"
                    type="text"
                    @input="onInput"
                >
            </div>
        </section>
    </settings-page>
</template>

<script>
import { mapState } from 'vuex';

import SettingsPage from '@/components/settings/shared/settings-page';

export default {
    name: 'settings-accessibility',
    components: { SettingsPage },

    data() {
        return {
            title: 'Accessibility',
            description: 'Accessibility settings for ADA compliance',
            enableBypassBlock: false,
            bypassBlockText: 'Skip to main content',
            targetId: 'main',
        };
    },

    computed: {
        ...mapState({
            settings: state => state.settings,
        }),
    },

    mounted() {
        this.enableBypassBlock = this.settings.accessibility.enableBypassBlock;
        this.bypassBlockText = this.settings.accessibility.bypassBlockText;
        this.targetId = this.settings.accessibility.bypassBlockTargetId;
    },

    methods: {
        onInput() {
            this.$emit('input', 'accessibility', {
                enableBypassBlock: this.enableBypassBlock,
                bypassBlockText: this.bypassBlockText,
                bypassBlockTargetId: this.targetId,
            });
        },
    },
};
</script>
